/* Los íconos de los temas de las fichas: trazo fino con el color del texto,
 * así toman el del tema sin una regla por cada uno. Dibujados acá y no traídos
 * de una librería porque son pocos y no cambian.
 *
 * SALIÓ DE ADENTRO DE `Persona.jsx` cuando la ficha de la unidad pidió lo
 * mismo (Igna, 02/10: «lo mismo para los vehículos»). Copiado, el ícono de
 * Papeles o el triángulo de los avisos serían dos dibujos que el día que se
 * retoque uno dejan de ser el mismo — es la razón de `BloqueFicha`, y la de
 * `Ubicacion` y `VeredictoRTO`.
 */
const TRAZOS = {
  ojo: (
    <>
      <circle cx="12" cy="12" r="3" />
      <path d="M2 12s3.6-7 10-7 10 7 10 7-3.6 7-10 7S2 12 2 12z" />
    </>
  ),
  tel: (
    <path d="M5 3h4l2 5-3 2a11 11 0 0 0 6 6l2-3 5 2v4a2 2 0 0 1-2 2A17 17 0 0 1 3 5a2 2 0 0 1 2-2z" />
  ),
  persona: (
    <>
      <circle cx="12" cy="8" r="4" />
      <path d="M4 21c1-4 4-6 8-6s7 2 8 6" />
    </>
  ),
  carpeta: <path d="M3 6h6l2 2h10v11H3z" />,
  /* La llave inglesa del tema Taller, en la ficha de la unidad. */
  llave: (
    <path d="M14.5 4a4.5 4.5 0 0 0-4.2 6.1L4 16.4V20h3.6l6.3-6.3A4.5 4.5 0 0 0 20 9.5l-2.8 2.8-2.7-.8-.8-2.7L16.5 6A4.5 4.5 0 0 0 14.5 4z" />
  ),
  alerta: (
    <>
      <path d="M12 3 2 20h20z" />
      <path d="M12 10v4M12 17v.5" />
    </>
  ),
};

const IconoFicha = ({ nombre }) => (
  <svg
    className="pf-icono"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    focusable="false"
  >
    {TRAZOS[nombre]}
  </svg>
);

export default IconoFicha;
